import {atomWithStore} from 'jotai-redux'
import {configureStore, combineReducers} from '@reduxjs/toolkit'

import {companyGroupReducer} from './companyGroup/reducer'
import {userReducer} from './user/reducer'
import {commonReducer} from './common/reducer'

const rootReducer = combineReducers({
  companyGroup: companyGroupReducer,
  user: userReducer,
  common: commonReducer,
})

const store = configureStore({reducer: rootReducer})

export type RootState = ReturnType<typeof store.getState>

export default atomWithStore(store)
